"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _transparentize = _interopRequireDefault(require("polished/lib/color/transparentize"));

var _transitions = _interopRequireDefault(require("polished/lib/shorthands/transitions"));

var _usePalette3 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _CheeryContainer = _interopRequireDefault(require("./CheeryContainer"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var alpha45 = (0, _transparentize["default"])(0.55);

var useStyles = function useStyles(withChildren) {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      fonts = _useTheme.fonts,
      spacing = _useTheme.spacing;

  var _usePalette = (0, _usePalette3["default"])(),
      button = _usePalette.button,
      highlight = _usePalette.highlight;

  var primary = button.primary,
      contrast = button.contrast;
  var shadow = alpha45(colors[highlight]);
  var extraStyle = {
    padding: spacing(0, 3)
  };

  if (!withChildren) {
    // this will create a perfect circle
    extraStyle = {
      width: spacing(8.3),
      padding: 0
    };
  }

  return {
    root: _objectSpread({}, fonts.button, {}, extraStyle, {
      fontWeight: 600,
      boxSizing: 'content-box',
      backgroundColor: colors[primary],
      color: colors[contrast],
      border: "1px solid ".concat(colors[primary]),
      borderRadius: spacing(6),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      minHeight: spacing(8.3),
      WebkitTapHighlightColor: 'transparent',
      textDecoration: 'none'
    }, (0, _transitions["default"])(['background-color', 'filter', 'opacity', 'border-color', 'color', 'box-shadow'], '0.2s ease-in-out'), {
      ':disabled': {
        cursor: 'auto',
        filter: 'grayscale(0.5)',
        opacity: 0.7
      },
      ':focus': {
        outline: 'none',
        boxShadow: "0 0 0 ".concat(spacing(1), " ").concat(shadow)
      },
      ':hover': {
        outline: 'none',
        boxShadow: "0 0 0 ".concat(spacing(1), " ").concat(shadow)
      }
    }),
    secondary: {
      color: colors[primary],
      backgroundColor: colors.transparent,
      border: "1px solid ".concat(colors[primary])
    },
    md: {
      minHeight: spacing(6.6),
      fontSize: spacing(2.3)
    },
    xl: {
      minHeight: spacing(12.3),
      fontSize: spacing(3.3)
    },
    text: {
      color: colors[primary],
      backgroundColor: colors.transparent,
      borderColor: colors.transparent,
      ':focus': {
        backgroundColor: shadow,
        boxShadow: 'none'
      },
      ':hover': {
        backgroundColor: shadow,
        boxShadow: 'none'
      }
    },
    icon: {
      color: 'inherit'
    }
  };
};

__signature__(useStyles, "useTheme{{ colors, fonts, spacing }}\nusePalette{{ button, highlight }}", function () {
  return [_useTheme2["default"], _usePalette3["default"]];
});

var iconSizes = {
  md: 4,
  lg: 4,
  xl: 6
};

var Cta = function Cta(props, ref) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'button' : _props$as,
      _props$size = props.size,
      size = _props$size === void 0 ? 'lg' : _props$size,
      variant = props.variant,
      icon = props.icon,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2["default"])(props, ["as", "size", "variant", "icon", "children", "className"]);
  var classes = useStyles(!!children);

  var _usePalette2 = (0, _usePalette3["default"])(),
      button = _usePalette2.button;

  var iconSize = iconSizes[size];

  if (variant === 'cheery') {
    return (0, _core.jsx)(_CheeryContainer["default"], {
      color: button.accent,
      className: className
    }, (0, _core.jsx)(Element, (0, _extends2["default"])({
      ref: ref,
      css: /*#__PURE__*/(0, _css2["default"])([classes.root, classes[variant], classes[size]], ";label:Cta;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
    }, other), (0, _core.jsx)(_Icon["default"], {
      css: classes.icon,
      size: iconSize,
      type: icon,
      margin: [0, 2, 0, 0]
    }), children));
  }

  return (0, _core.jsx)(Element, (0, _extends2["default"])({
    ref: ref,
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, classes[variant], classes[size]], ";label:Cta;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    className: className
  }, other), (0, _core.jsx)(_Icon["default"], {
    css: classes.icon,
    size: iconSize,
    type: icon,
    margin: children ? [0, 2, 0, 0] : [0]
  }), children);
};

__signature__(Cta, "useStyles{classes}\nusePalette{{ button }}", function () {
  return [useStyles, _usePalette3["default"]];
});

var _default = (0, _react.forwardRef)(Cta);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(alpha45, "alpha45", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/index.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/index.tsx");
  reactHotLoader.register(iconSizes, "iconSizes", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/index.tsx");
  reactHotLoader.register(Cta, "Cta", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();